import { FC, ReactNode } from 'react'

import { match } from 'ts-pattern'
import {
  GreenGreen70,
  GreyGrey60,
  SignerList,
  SignerListItemStyles,
  Center,
  Box
} from '@sequencehq/core-components'

type SignerLastSeenStatus = 'ONLINE' | 'OFFLINE'

const Wrapper: FC<{
  children: ReactNode
  'data-testid'?: string
}> = props => <SignerList {...props} />

const Item: FC<{
  name: string
  email: string
  status: SignerLastSeenStatus
  badgeText?: string
  caption: string
  styles?: SignerListItemStyles
}> = props => (
  <SignerList.Item
    {...props}
    icon={<SignerListItemIcon status={props.status} />}
    data-testid={`signerLastSeenList.item.${props.email}`}
    data-status={props.status}
    caption={props.caption}
    styles={props.styles}
  />
)

const OnlineStatusIcon: FC<{ backgroundColor: string }> = ({
  backgroundColor
}) => (
  <Box
    width="8px"
    height="8px"
    borderRadius="8px"
    backgroundColor={backgroundColor}
  />
)

const SignerListItemIcon: FC<{ status: SignerLastSeenStatus }> = ({
  status
}) => (
  <Center width="16px" height="16px" flexShrink="0">
    {match(status)
      .with('ONLINE', () => <OnlineStatusIcon backgroundColor={GreenGreen70} />)
      .with('OFFLINE', () => <OnlineStatusIcon backgroundColor={GreyGrey60} />)
      .exhaustive()}
  </Center>
)

export const SignerLastSeenList = Object.assign(Wrapper, {
  Item
})
